import type { TrendItemContentTweetsItemAuth } from './trendItemContentTweetsItemAuth';
import type { TrendItemContentTweetsItemAuthor } from './trendItemContentTweetsItemAuthor';
import type { TrendItemContentTweetsItemBasicInfo } from './trendItemContentTweetsItemBasicInfo';
import type { TrendItemContentTweetsItemEngagement } from './trendItemContentTweetsItemEngagement';
import type { TrendItemContentTweetsItemMedia } from './trendItemContentTweetsItemMedia';
import type { TrendItemContentTweetsItemPoll } from './trendItemContentTweetsItemPoll';
import type { TrendItemContentTweetsItemReferencedTweet } from './trendItemContentTweetsItemReferencedTweet';
import type { TrendItemContentTweetsItemTags } from './trendItemContentTweetsItemTags';
import type { TrendItemContentTweetsItemUserInteraction } from './trendItemContentTweetsItemUserInteraction';

export type TrendItemContentTweetsItem = {
  /** 인증 컨텍스트 정보 */
  auth?: TrendItemContentTweetsItemAuth;
  /** 트윗 작성자 정보 */
  author?: TrendItemContentTweetsItemAuthor;
  basicInfo?: TrendItemContentTweetsItemBasicInfo;
  engagement?: TrendItemContentTweetsItemEngagement;
  /** 미디어 정보 */
  media?: TrendItemContentTweetsItemMedia;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: TrendItemContentTweetsItemPoll;
  /** 참조된 트윗 정보 (답글, 인용, 리트윗인 경우) */
  referencedTweet?: TrendItemContentTweetsItemReferencedTweet;
  /** 트윗 태그 정보 */
  tags?: TrendItemContentTweetsItemTags;
  /** 사용자 상호작용 정보 */
  userInteraction?: TrendItemContentTweetsItemUserInteraction;
};
